import ApplicationConfig from './app.config';
import AuthenticationConfig from './authConfig';
import AuthenticationInterceptor from './interceptors/authInterceptor';
import ErrorInterceptor from './interceptors/errorsInterceptor';
import HttpDecorator from './http.decorator.config';
import HttpCaching from './httpCaching.config';
import IeCors from './ieCORS';
import SpinnerInterceptor from './interceptors/spinnerInterceptor';
import TimeoutInterceptor from './interceptors/timeout-interceptor';
import UiRouterTypeCustomDate from './ui-router-type-custom-date';

const MODULE_NAME = 'app.config';
const module = angular
    .module(MODULE_NAME, [])
    .config(ApplicationConfig)
    .config(AuthenticationInterceptor)
    .config(ErrorInterceptor)
    .config(HttpDecorator)
    .config(HttpCaching)
    .config(SpinnerInterceptor)
    .config(TimeoutInterceptor)
    .config(UiRouterTypeCustomDate)
    .run(AuthenticationConfig)
    .run(IeCors)
    .run((googleMapsService) => {
        'ngInject';
        googleMapsService.loadGoogleMaps();
    });

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/configs/config-module.js